import { TableCell, TableRow } from "@material-ui/core";
import styled from "styled-components";
import globalColors from "../../../../../../../_metronic/_assets/sass/custom/globalColors.scss";

//linhas tas tabela
export const StyledTableRow = styled(TableRow)`
  &:nth-of-type(odd) {
    background-color: ${globalColors.colorWhite};
  }
`;

export const StyledTableCell = styled(TableCell)`
  &.MuiTableCell-head {
    position: relative;
    font-family: "Open Sans";
    font-weight: 700;
    font-size: 12px;
    line-height: 24px;
    text-align: center;

    padding: 8px;
    color: globalColors;
    background: ${globalColors.colorWhite};
  }

  &.MuiTableCell-head,
  &.MuiTableSortLabel-active {
    svg {
      color: ${globalColors.primaryColor2} !important;
    }
  }

  &.MuiTableCell-head:first-child {
    border-top-left-radius: 4px;
    padding-left: 16px;
  }

  &.MuiTableCell-head:last-child {
    border-top-right-radius: 4px;
  }

  &.MuiTableCell-root.MuiTableCell-body {
    position: relative;
    font-family: "Open Sans";
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
    color: ${globalColors.textColor2};
    text-align: center;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    padding: 4px 7px;

    max-width: 250px;

    &:first-child {
      padding-left: 16px;
    }
  }

  &:last-child td,
  &:last-child th {
    border: 0;
  }

  .link {
    text-decoration: underline;
  }
`;

export const StyledTableContent = styled.div`
  background-color: #f9f7f6;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12),
    0px 2px 4px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-height: calc(100vh - 41px);
`;

export const OpenContainerButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${globalColors.primaryColor2};

  position: relative;
  right: 15px;

  top: 50%;

  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;

  padding: 0px;

  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12),
    0px 1px 3px rgba(0, 0, 0, 0.2);
  transform: matrix(-1, 0, 0, 1, 0, 0);

  transition: filter 0.2s;
  transition: width 0.8s;

  .arrow {
    width: 24px;
    height: 20px;
    color: ${globalColors.colorWhite};
  }

  &:hover {
    filter: brightness(0.9);
  }

  background-color: "red" !important;

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const ImageContainer = styled.div`
  width: ${({ showMap }) => (showMap ? "84vw" : "0vw")};
  background: ${globalColors.colorWhite};

  margin-left: 4px;

  transition: width 0.8s;

  img {
    display: ${({ showMap }) => (!showMap ? "none" : "flex")};
    margin: 0 auto;

    position: relative;
    top: 24%;
  }
`;

export const Status = styled.div`
  color: ${({ status }) =>
    status === "Disponível"
      ? globalColors.primaryColor2
      : status === "Ocupado"
        ? globalColors.primaryColor4
        : status === "Inadimplente"
          ? globalColors.secondaryColor2
          : status === "Manutenção"
            ? globalColors.primaryColor4
            : globalColors.textColor2};
`;
